export default __webpack_public_path__ + "4247c77fcb5bbdebad6b78b4a1ba0dbc.png";